import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464fd6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Source"),
    /*#__PURE__*/_createElementVNode("th", null, "Target"),
    /*#__PURE__*/_createElementVNode("th", null, "Create By"),
    /*#__PURE__*/_createElementVNode("th", null, "Rule Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Update On"),
    /*#__PURE__*/_createElementVNode("th", null, "Create On"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_6 = { colspan: "12" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "typeBadge" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "typeBadge" }
const _hoisted_13 = ["onClick"]

import { ref, onMounted } from "vue";
import TimeShow from "@/components/TimeShow.vue";
import RebateService from "../services/RebateService";
import TableFooter from "@/components/TableFooter.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingConfirmation',
  setup(__props) {

const router = useRouter();
const isLoading = ref(true);
const deleteIndex = ref(-1);
const rebateRules = ref(Array<any>());

const criteria = ref({
  page: 1,
  size: 10,
  numPages: 1,
  total: 0,
  isConfirmed: false,
});

onMounted(async () => {
  await fetchData(1);
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const responseBody = await RebateService.queryDirectRebateRules(
      criteria.value
    );
    criteria.value = responseBody.criteria;
    criteria.value.isConfirmed = false;

    rebateRules.value = responseBody.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const pageChange = (_page: number) => {
  fetchData(_page);
};

const handleCheckRebate = (item) => {
  router.push({
    name: "accountClients",
    query: {
      action: "checkRebate",
      rebateId: item.id,
      accountId: item.sourceAccount.id,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(ScaleLoader)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && rebateRules.value.length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t("tip.nodata")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && rebateRules.value.length != 0)
          ? (_openBlock(), _createBlock(_TransitionGroup, {
              key: 2,
              tag: "tbody",
              name: "table-delete-fade",
              class: "table-delete-fade-container fw-semibold"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateRules.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item,
                    class: _normalizeClass({ 'table-delete-fade-active': index === deleteIndex.value })
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(item.sourceAccount.name), 1),
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, "Account No: " + _toDisplayString(item.sourceAccount.accountNumber), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(item.targetAccount.name), 1),
                      _hoisted_11,
                      _createElementVNode("span", _hoisted_12, "UID: " + _toDisplayString(item.targetAccount.uid), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.rebateRuleName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.createdByName), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-light btn-success btn-sm me-3",
                        onClick: ($event: any) => (handleCheckRebate(item))
                      }, _toDisplayString(_ctx.$t("action.check")), 9, _hoisted_13)
                    ])
                  ], 2))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(TableFooter, {
        onPageChange: pageChange,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ])
  ]))
}
}

})